import { STATUS_PROCESS_OBV } from '../../constants/status';
import { createSlice } from '@reduxjs/toolkit'
import { INITIAL_STATE } from "./initialState.js";

const appSlice = createSlice({
  name: "plaidAction",
  initialState: INITIAL_STATE,
  reducers: {
    SHOW_LOADING: (state) => {
      return { ...state, isLoading: true };
    },
    HIDE_LOADING: (state) => {
      return { ...state, isLoading: false };
    },
    SHOW_PLAID_FOOTER: (state) => {
      return { ...state, hidePlaidFooter: false };
    },
    HIDE_PLAID_FOOTER: (state) => {
      return { ...state, hidePlaidFooter: true };
    },
    CREATE_OBV_SUCCESS: (state, action) => {
      return {
        ...state,
        code: action.payload.code,
        statusProcess: STATUS_PROCESS_OBV.INIT,
        xAuthToken: action.payload.xAuthToken,
        merchantReturnUrl: action.payload.merchantReturnUrl,
        obvInfo: { ...state.obvInfo, ...action.payload.data },
        theme: action.payload.theme
      };
    },
    CREATE_OBV_FAILURE: (state, action) => {
      return {
        ...state,
        error: action.payload.error,
        theme: action.payload.theme,
      };
    },
    CREATE_PLAID_LINK_SUCCESS: (state, action) => {
      return {
        ...state,
        statusProcess: STATUS_PROCESS_OBV.INIT,
        obvInfo: { ...state.obvInfo, token: action.payload.data.token }
      };
    },
    CREATE_PLAID_LINK_FAILURE: (state, action) => {
      return { ...state, error: action.payload.error };
    },
    CREATE_LINK_EVENT_SUCCESS: (state) => {
      return { ...state };
    },
    CREATE_LINK_EVENT_FAILURE: (state, action) => {
      return {
        ...state,
        error: action.payload.error,
      };
    },
    OBV_VERIFICATION_SUCCESS: (state, action) => {
      return {
        ...state,
        isVerification: true,
        obvInfo: { ...state.obvInfo, ...action.payload.response  }
      };
    },
    OBV_VERIFICATION_FAILURE: (state, action) => {
      return { ...state, error: action.payload.error };
    },
    EXIT_EVENT_SUCCESS: (state) => {
      return { ...state, isBackMerchant: true, isExitSuccess: true };
    },
    EXIT_EVENT_FAILURE: (state, action) => {
      return { ...state, error: action.payload.error };
    },
    BACK_TO_MERCHANT: (state) => {
      return { ...state, isBackMerchant: true };
    },
    CONFIRM_BANK_SUCCESS: (state) => {
      return { ...state, isConfirm: true, isBackMerchant: true };
    },
    CONFIRM_BANK_FAILURE: (state, action) => {
      return { ...state, error: action.payload.error };
    },
    CONTINUE_OAUTH_CALLBACK_SUCCESS: (state, action) =>{
      return { 
        ...state, 
        ...action.payload,
        statusProcess: STATUS_PROCESS_OBV.CONTINUE_OAUTH_CALLBACK_SUCCESS
      };
    },
    CONTINUE_OAUTH_CALLBACK_FAILURE: (state, action) => {
      return { ...state, error: action.payload.error, deviceData: action.payload.deviceData };
    },
    UPDATE_OBV_INFO: (state, action) => {
      return {
        ...state,
        verification: true,
        obvInfo: { ...state.obvInfo, ...action.payload.response }
      };
    },
    ADDING_PROPERTIES: (state, action) => {
      return {
        ...state,
        obvInfo: {
          ...state.obvInfo,
          properties: { ...action.payload }
        }
      };
    },
  },
});


export const {
  CONFIRM_BANK_FAILURE,
  CONFIRM_BANK_SUCCESS,
  CREATE_LINK_EVENT_FAILURE,
  CREATE_LINK_EVENT_SUCCESS,
  CREATE_OBV_FAILURE,
  CREATE_OBV_SUCCESS,
  CREATE_PLAID_LINK_FAILURE,
  CREATE_PLAID_LINK_SUCCESS,
  EXIT_EVENT_FAILURE,
  EXIT_EVENT_SUCCESS,
  BACK_TO_MERCHANT,
  HIDE_LOADING,
  OBV_VERIFICATION_FAILURE,
  OBV_VERIFICATION_SUCCESS,
  SHOW_LOADING,
  UPDATE_OBV_INFO,
  SHOW_PLAID_FOOTER,
  HIDE_PLAID_FOOTER,
  ADDING_PROPERTIES,
  CONTINUE_OAUTH_CALLBACK_SUCCESS,
  CONTINUE_OAUTH_CALLBACK_FAILURE,
} = appSlice.actions;

export default appSlice.reducer;
